import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import MintUI from 'mint-ui';
import './assets/styles/global.css';
import TimeLine from 'uni-time-line';
import 'mint-ui/lib/style.css';
import Moment from 'moment';
import VueJsonp from 'vue-jsonp';
import Commom from './utils/common.js';
import common from '../static/common_js/common.js';
import axios from 'axios';
import Vant from 'vant';
import 'vant/lib/index.css';
import * as filters from '@/utils/filters';
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});
// import fliter from '@/utils/fliters'
// import Calendar from 'vue-mobile-calendar'
// Vue.use(Calendar);
Vue.use(Vant);
Vue.use(common);

// Vue.use(Commom)
Vue.prototype.Commom = Commom;
Vue.prototype.axios = axios;

Vue.config.productionTip = false;
Vue.use(TimeLine);
/* eslint-disable no-new */

Vue.use(VueJsonp);

Vue.use(MintUI);
// Vue.prototype.$moment = moment;
// moment.locale('zh-cn')
// Vue.use(Vue)

// if (process.env.NODE_ENV === 'production') {
setInterval(() => {
    // 重复创建script标签，先删除
    // const preScript = document.getElementsByTagName("script")[0];
    // const preSrc = preScript.src;
    // const parentNode = preScript.parentNode
    // if (preSrc.includes('version')) {
    //   parentNode.removeChild(preScript)
    // }
    // const versionScript = document.createElement("script");
    // // todo 注意路径问题
    // versionScript.src = '/openweb/common/version.js?v=' + new Date().getTime();
    // const s = document.getElementsByTagName("script")[0];
    // parentNode.insertBefore(versionScript, s); // 插入到head标签中 layout.js前

    window.getVersion = (version) => {
        if ((localStorage.frontendVersion && version !== localStorage.frontendVersion) || (window.frontendVersion && version !== window.frontendVersion)) {
            console.log('localStorage.frontendVersion', localStorage.frontendVersion);
            console.log('version', version);
            alert('请更新');
            // Vue.prototype.$confirm({
            //   title: '页面有更新，确定要更新吗？',
            //   onOk() {
            //     location.reload()
            //   },
            //   onCancel() {},
            // });
        }
        localStorage.frontendVersion = version; // 保存 以便下次使用判断
        window.frontendVersion = version; // 保存 以便下次使用判断
    };
}, 10000);
// }

new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js